export const FROM_REGISTRATION = 'FROM_REGISTRATION';
export const FINISH_REGISTRATION = 'FINISH_REGISTRATION';